// rem 及其转换
const remUnit = 75
const px2rem = px => px / remUnit

// 每一个格子的宽度和高度
const gridWidth = 60
const gridHeight = 50

// 坐标轴的单位长度
const unitX = gridWidth / 4
const unitY = gridHeight / 2

// 板块之间需要重叠的便宜量
const offsetYUnit = 0.16 * gridHeight
const offsetXUnit = 0.04 * gridWidth

// 格子地图
const roadMap = [
  { idx: 0, x: 11, y: 11, z: 18, offsetX: 0, offsetY: 0 },
  { idx: 1, x: 8, y: 10, z: 17, offsetX: -2, offsetY: 0 },
  { idx: 2, x: 5, y: 9, z: 16, offsetX: -2, offsetY: 0 },
  { idx: 3, x: 2, y: 8, z: 15, offsetX: -2, offsetY: 0 },
  { idx: 4, x: 2, y: 6, z: 12, offsetX: -2, offsetY: offsetYUnit * 1 },
  { idx: 5, x: 2, y: 4, z: 11, offsetX: -2, offsetY: offsetYUnit * 2 },
  { idx: 6, x: 5, y: 3, z: 10, offsetX: -2, offsetY: offsetYUnit * 2 },
  { idx: 7, x: 5, y: 1, z: 9, offsetX: -2, offsetY: offsetYUnit * 3 },
  { idx: 8, x: 8, y: 0, z: 8, offsetX: -2, offsetY: offsetYUnit * 3 },
  { idx: 9, x: 11, y: 1, z: 8, offsetX: 0, offsetY: offsetYUnit * 2.5 },
  { idx: 10, x: 14, y: 0, z: 7, offsetX: 2, offsetY: offsetYUnit * 3 },
  { idx: 11, x: 17, y: 1, z: 7, offsetX: 2, offsetY: offsetYUnit * 3 },
  { idx: 12, x: 20, y: 2, z: 7, offsetX: 2, offsetY: offsetYUnit * 3 },
  { idx: 13, x: 20, y: 4, z: 7, offsetX: 2, offsetY: offsetYUnit * 2 },
  { idx: 14, x: 20, y: 6, z: 7, offsetX: 2, offsetY: offsetYUnit * 1 },
  { idx: 15, x: 20, y: 8, z: 7, offsetX: 2, offsetY: offsetYUnit * 0 },
  { idx: 16, x: 17, y: 9, z: 7, offsetX: 2, offsetY: offsetYUnit * 0 },
  { idx: 17, x: 14, y: 10, z: 7, offsetX: 2, offsetY: offsetYUnit * 0 },
]
// 18
// 计算格子的位置
const getComputeSite = (road) => {
  const { x, y, z = 0, offsetX, offsetY, idx } = road
  const widthP = px2rem(gridWidth);
  const heightP = px2rem(gridHeight);
  const l = px2rem(x * unitX + offsetX)
  const t = px2rem(y * unitY + offsetY)
  if (idx === 0) return { width: `${0.9467}rem`, height: `${0.8533}rem`, left: `${l - 0.08}rem`, top: `${t - 0.12}rem`, zIndex: z }
  return { width: `${widthP}rem`, height: `${heightP}rem`, left: `${l}rem`, top: `${t}rem`, zIndex: z };
};

export const roads = roadMap.map(getComputeSite)

export class ActivityInfo {
  constructor () {
    this.activityId = ''
    this.activityStatus = 1
    this.banner = ''
    this.gameVoList = []
    this.name = ''
    this.startTime = ''
  }
}

export const FEEDTYPE_MAP = {
  SUCCESS: 'SUCCESS', // 成功
  INSUFFICIENT_GIFT: 'INSUFFICIENT_GIFT', // 礼包码不足
  SHOW_GIFT: 'SHOW_GIFT', // 礼包展示
  MORE_GAME: 'MORE_GAME', // 更多游戏
  REACH_LIMIT: 'REACH_LIMIT', // 已达上限
  NO_ROLE: 'NO_ROLE', // 没有角色
  NO_CHANCE: 'NO_CHANCE', // 没有机会
  CONDITION_NOT_SATISFY: 'CONDITION_NOT_SATISFY', // 条件不满足
}
